/**
 * @generated SignedSource<<6a645351a63b3079d1aa7a8fdf55dc9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalWorkspaceTemplateSelectorCreateTemplatePopupMutation$variables = {
  name: string;
  signalWorkspaceId: string;
};
export type SignalWorkspaceTemplateSelectorCreateTemplatePopupMutation$data = {
  readonly signalWorkspace: {
    readonly createTemplate: {
      readonly signalWorkspace: {
        readonly " $fragmentSpreads": FragmentRefs<"SignalWorkspaceTemplateSelector_SignalWorkspace">;
      };
      readonly workspace: {
        readonly " $fragmentSpreads": FragmentRefs<"SignalWorkspaceTemplateSelector_workspace">;
      } | null;
    } | null;
  };
};
export type SignalWorkspaceTemplateSelectorCreateTemplatePopupMutation = {
  response: SignalWorkspaceTemplateSelectorCreateTemplatePopupMutation$data;
  variables: SignalWorkspaceTemplateSelectorCreateTemplatePopupMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "signalWorkspaceId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "signalWorkspaceId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "__typename",
    "storageKey": null
  },
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignalWorkspaceTemplateSelectorCreateTemplatePopupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspaceTemplateCreateResult",
            "kind": "LinkedField",
            "name": "createTemplate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SignalWorkspaceTemplateSelector_workspace"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SignalWorkspace",
                "kind": "LinkedField",
                "name": "signalWorkspace",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SignalWorkspaceTemplateSelector_SignalWorkspace"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SignalWorkspaceTemplateSelectorCreateTemplatePopupMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "SignalWorkspaceTemplateCreateResult",
            "kind": "LinkedField",
            "name": "createTemplate",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SignalWorkspaceTemplate",
                    "kind": "LinkedField",
                    "name": "signalTemplates",
                    "plural": true,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SignalWorkspace",
                "kind": "LinkedField",
                "name": "signalWorkspace",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "updatedBy",
                    "plural": false,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "descriptionFiles",
                    "plural": true,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "descriptionImages",
                    "plural": true,
                    "selections": (v6/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SignalWorkspaceTemplate",
                    "kind": "LinkedField",
                    "name": "template",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b0ced0ce4b5459f43ff67e9208fcf2c7",
    "id": null,
    "metadata": {},
    "name": "SignalWorkspaceTemplateSelectorCreateTemplatePopupMutation",
    "operationKind": "mutation",
    "text": "mutation SignalWorkspaceTemplateSelectorCreateTemplatePopupMutation(\n  $signalWorkspaceId: ID!\n  $name: String!\n) {\n  signalWorkspace(id: $signalWorkspaceId) {\n    createTemplate(name: $name) {\n      workspace {\n        ...SignalWorkspaceTemplateSelector_workspace\n        id\n      }\n      signalWorkspace {\n        ...SignalWorkspaceTemplateSelector_SignalWorkspace\n        id\n      }\n    }\n  }\n}\n\nfragment SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate on SignalWorkspaceTemplate {\n  id\n  name\n}\n\nfragment SignalWorkspaceTemplateSelector_SignalWorkspace on SignalWorkspace {\n  id\n  updatedBy {\n    __typename\n    id\n  }\n  body\n  title\n  descriptionFiles {\n    __typename\n    id\n  }\n  descriptionImages {\n    __typename\n    id\n  }\n  template {\n    id\n    name\n    ...SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate\n  }\n}\n\nfragment SignalWorkspaceTemplateSelector_workspace on Workspace {\n  id\n  signalTemplates {\n    id\n    ...SignalWorkspaceTemplateSelectorTemplateItem_SignalWorkspaceTemplate\n  }\n}\n"
  }
};
})();

(node as any).hash = "c14f3d4dc9e8daa342af890a3b8f263a";

export default node;
